import { useEffect } from 'react';
import { useFindByQuery } from '../../graphql';
import { useCurrentAccount, useCurrentWorkspace } from '../../auth';

const FIND_WORKSPACE_LABELS = `
  query FindWorkspaceLabels($filter: LabelFilter) {
    findLabels(filter: $filter) {
      items {
        id
        name
      }
    }
  }
`;

export const useWorkspaceLabels = (workspaceId?: string, storageOnly?: boolean) => {
  const { account } = useCurrentAccount();
  const currentWorkspace = useCurrentWorkspace(storageOnly);
  // Workspace resolution priority:
  // 1) Explicit workspaceId passed to the hook
  // 2) Current workspace from storage/impersonation
  // 3) Account.workspace (covers Global Admin with a selected workspace but no impersonation)
  const targetWorkspaceId =
    workspaceId || currentWorkspace?.id || account?.workspace?.id;

  const { data, isLoading, refetch } = useFindByQuery({
    modelName: 'label',
    query: FIND_WORKSPACE_LABELS,
    variables: targetWorkspaceId ? {
      filter: {
        workspace: { eq: targetWorkspaceId }
      }
    } : undefined,
    options: {
      enabled: !!targetWorkspaceId, // Only fetch when workspace ID is available
    },
  });

  // Auto-refetch when workspaceId becomes available
  useEffect(() => {
    if (targetWorkspaceId) {
      refetch();
    }
  }, [targetWorkspaceId, refetch]);

  return {
    labels: data?.items || [],
    isLoading,
    refetch,
  };
};
